var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('Navbar'),(_vm.overlayStatus)?_c('div',{staticClass:"overlay"}):_vm._e(),_c('div',[_vm._t("default",null,{"id":"view-router"}),_c('Footer'),_c('FooterCopyright')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }